import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.5 1.75a.75.75 0 0 1 .75.75v.321l.404-.057a6.5 6.5 0 0 1 3.55.494l1.701.756a2.54 2.54 0 0 0 2.167-.05.64.64 0 0 1 .928.574v5.538a.85.85 0 0 1-.339.679 3.36 3.36 0 0 1-3.517.316l-1.261-.63a5.64 5.64 0 0 0-2.925-.58l-.708.05V14a.75.75 0 0 1-1.5 0V2.5a.75.75 0 0 1 .75-.75m4.095 2.878a5 5 0 0 0-2.729-.379l-.366.052v4.088l.352-.025a7.14 7.14 0 0 1 3.7.736l1.262.63a1.86 1.86 0 0 0 1.686-.012V5.692a4.04 4.04 0 0 1-2.204-.308z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }